import { IconDiamond, IconRocket, IconUsers } from '../../componentes/Icons';
import './EstatisticasMaster.css';

const EstatisticasMaster = ({ tenantsCount, estimatedRevenue, activeTenantsCount }) => {
    return (
        <section className="master-stats-grid">
            <div className="m-stat-card">
                <div className="m-stat-icon" style={{ color: 'var(--text-dim)' }}><IconUsers /></div>
                <div className="m-stat-info">
                    <span className="m-label">Total de Clientes</span>
                    <span className="m-value">{tenantsCount}</span>
                </div>
            </div>
            <div className="m-stat-card highlight">
                <div className="m-stat-icon" style={{ color: 'var(--gold-primary)' }}><IconDiamond /></div>
                <div className="m-stat-info">
                    <span className="m-label">MRR Estimado</span>
                    <span className="m-value">R$ {estimatedRevenue.toLocaleString('pt-BR')}</span>
                </div>
            </div>
            <div className="m-stat-card">
                <div className="m-stat-icon" style={{ color: 'var(--accent-green)' }}><IconRocket /></div>
                <div className="m-stat-info">
                    <span className="m-label">Lojas Ativas</span>
                    <span className="m-value">{activeTenantsCount}</span>
                </div>
            </div>
        </section>
    );
};

export default EstatisticasMaster;
